import { render, staticRenderFns } from "./DeleteWarehouseModal.vue?vue&type=template&id=185f158e&"
import script from "./DeleteWarehouseModal.vue?vue&type=script&lang=js&"
export * from "./DeleteWarehouseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports